import styled from 'styled-components'

import { Doctor } from '@/apiTypes.ts'
import { DoctorImage, DoctorInitials } from '@/components/Doctor.tsx'
import { BodyM, BodyS } from '@/components/Text.tsx'

const StyledDoctor = styled.div`
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.colors.common.border};
  border-radius: 4px;
`

const DoctorImg = styled.div`
  position: relative;
  top: 3px;
  flex: 0 0 60px;
`

const DoctorDetail = styled.div`
  display: flex;
  flex-flow: column;
`

const DoctorDetailHeading = styled(BodyM)`
  color: ${({ theme }) => theme.colors.common.black95};
  font-weight: 500;
`

const DoctorCaption = styled(BodyS)`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.common.black62};
`

export const DoctorCard = ({ doctor }: { doctor: Doctor }) => {
  return (
    <StyledDoctor>
      <DoctorImg>
        {doctor.picture ? (
          <DoctorImage src={doctor.picture} alt={doctor.name} />
        ) : (
          <DoctorInitials name={doctor.name} />
        )}
      </DoctorImg>
      <DoctorDetail>
        <DoctorDetailHeading>{doctor.name}</DoctorDetailHeading>
        <DoctorCaption>{doctor.title}</DoctorCaption>
        <BodyM>{doctor.shortDescription}</BodyM>
      </DoctorDetail>
    </StyledDoctor>
  )
}
